import axios from "axios";
export default {
	data() {
		return {
			numeratoriPathResources: "/numeratori/elenco",
		};
	},
	methods: {
		numeratoriLoadData(numeratoriLoadDataSuccess, codiceStruttura) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.numeratoriPathResources + "?codiceStruttura=" + codiceStruttura;
			axios.get(link)
				.then((response) => {
					numeratoriLoadDataSuccess(response);
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
	},
};
